export enum ChangeEmailFormFields {
  email = 'email',
  newEmail = 'newEmail',
}

export type ChangeEmailFormValues = {
  [ChangeEmailFormFields.email]: string;
  [ChangeEmailFormFields.newEmail]: string;
};
